/* eslint-disable sonarjs/no-duplicate-string */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { take } from 'rxjs/operators';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import {
  AgencyListRequest,
  AgencyListRes,
  PostAffirmRequestPayload,
  PostAffirmSuccessRes,
  ValidationResponse,
} from './app.model';
import { MOCK_AGENCY_LIST } from './app.service.mock';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  apiUrl: string;
  appHeader = {};
  isRegistrationStatusToLogin = false;
  isFpStatusToLogin = false;
  private readonly isIntegrationOnSubject = new BehaviorSubject<boolean>(false);
  isIntegrationOn$ = this.isIntegrationOnSubject.asObservable();
  availableScriptTags: HTMLScriptElement[];
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);
  constructor(
    private _http: HttpClient,
    public _gw: AppStateGateway,
    private featureTogglesFacade: FeatureTogglesFacade,
    private translate: TranslateService,
  ) {}

  redirectToExtUrl(extUrl: string, target: string) {
    this.isOktaLoginEnabled$
      .pipe(take(1))
      .subscribe((isOktaLoginEnabled: boolean) => {
        const isOktaExtRedirectUrl = this.translate.instant(
          `global.isOktaExtRedirectUrl`,
        );
        if (isOktaLoginEnabled && isOktaExtRedirectUrl === 'true') {
          const oktaExtRedirect = this._gw.getOktaExtRedirect(extUrl);
          window.open(oktaExtRedirect, target);
        } else {
          window.open(extUrl, target);
        }
      });
  }

  getBrokerQuoteMedical(roleId: string, brokerId: string) {
    this.apiUrl = this._gw
      .getBrokerQuoteMedical()
      ?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_self');
  }
  getBrokerQuoteDental() {
    this.apiUrl = this._gw.getBrokerQuoteDental();
    this.redirectToExtUrl(this.apiUrl, '_self');
  }

  getBrokerQuoteDentalAdmin(roleId: string, brokerId: string) {
    this.apiUrl = this._gw
      .getBrokerQuoteDentalAdmin()
      ?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_self');
  }
  getIfpMedicalAdmin(roleId: string, brokerId: string) {
    this.apiUrl = this._gw
      .getIfpMedicalAdmin()
      ?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_blank');
  }

  getBrokerBobPlans(roleId: string, brokerId: string) {
    this.apiUrl = this._gw
      .getBrokerBobPlans()
      ?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_self');
  }
  getIfpCompExt(roleId: string, brokerId: string) {
    this.apiUrl = this._gw.getIfpCompExt()?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_self');
  }

  getIfpResourceCenterExt(roleId: string, brokerId: string) {
    this.apiUrl = this._gw
      .getIfpResourceCenterExt()
      ?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_self');
  }
  getAgencyList(): Observable<AgencyListRes> {
    this.apiUrl = this._gw.getAgencyList();
    return this._http.get<AgencyListRes>(this.apiUrl);
    // return of(MOCK_AGENCY_LIST);
  }

  getKeepAlive(): Observable<any> {
    this.apiUrl = this._gw.getKeepAlive();
    const appHeader = { 'Content-Type': 'application/octet-stream' };
    return this._http.get(this.apiUrl, {
      headers: new HttpHeaders(appHeader),
    });
  }
  getIfpMedicalExtAgent() {
    this.apiUrl = this._gw.getIfpMedicalExtAgent();
    this.redirectToExtUrl(this.apiUrl, '_blank');
  }
  getUserSession(
    roleId: string,
    brokerId: string,
  ): Observable<ValidationResponse> {
    this.apiUrl = this._gw.getUserSession();

    const requestPayload = {
      roleId: `${roleId}`,
      brokerId: `${brokerId}`,
    };

    return this._http.post<ValidationResponse>(this.apiUrl, requestPayload);
  }

  postAffirm(
    request: PostAffirmRequestPayload,
  ): Observable<PostAffirmSuccessRes> {
    this.apiUrl = this._gw.postAffirm();
    return this._http.post<PostAffirmSuccessRes>(this.apiUrl, request);
  }

  setRegistrationStatusToLogin(isSuccess: boolean) {
    this.isRegistrationStatusToLogin = isSuccess;
  }

  getRegistrationStatusToLogin() {
    return this.isRegistrationStatusToLogin;
  }

  setfpStatusToLogin(isSuccess: boolean) {
    this.isFpStatusToLogin = isSuccess;
  }

  getfpStatusToLogin() {
    return this.isFpStatusToLogin;
  }

  setIntegrationOn(isIntegrationOn: boolean): void {
    this.isIntegrationOnSubject.next(isIntegrationOn);
  }
}
